import { apiAction } from 'bento-ordering/base/utils/apiHelpers';

import { CART_ITEMS_AVAILABLE_ENDPOINT } from 'bento-ordering/base/constants/endpoints';
import {
  CART_ITEMS_AVAILABLE_REQUEST,
  CART_ITEMS_AVAILABLE_SUCCESS,
  CART_ITEMS_AVAILABLE_FAILURE,
  CART_ITEMS_AVAILABLE_RESET
} from 'bento-ordering/cart/constants/actionTypes';
import getGroupOrderQueryParam from 'bento-ordering/base/utils/getGroupOrderQueryParam';

/**
 * Determine if the current cart items are available
 * base on the cart fulfillment date and time
 */
export const getIsCartItemsAvailable = fulfillmentOptions => (
  dispatch,
  getState
) => {
  const endpoint = CART_ITEMS_AVAILABLE_ENDPOINT;
  const state = getState();
  const queryParams = getGroupOrderQueryParam(state);

  return dispatch(
    apiAction(
      endpoint,
      'PUT',
      [
        CART_ITEMS_AVAILABLE_REQUEST,
        CART_ITEMS_AVAILABLE_SUCCESS,
        CART_ITEMS_AVAILABLE_FAILURE
      ],
      fulfillmentOptions,
      queryParams
    )
  );
};

/**
 * Reset the cartAvailable state to true
 */
export const resetIsCartItemAvailable = () => {
  return { type: CART_ITEMS_AVAILABLE_RESET };
};
